import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    sales: [],
    expenses: [],
    income: [],
     dateRanges: [],
  },
  loading: false,
  error: null,
};

const pnlReportSlice = createSlice({
  name: "PnlTrend",
  initialState,
  reducers: {
    PnlTrendRequest(state) {
      state.loading = true;
      state.error = null;
    },
    PnlTrendSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; // payload contains { sales, buys, expenses, income }
    },
    PnlTrendFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  PnlTrendRequest,
  PnlTrendSuccess,
  PnlTrendFailure,
} = pnlReportSlice.actions;

export default pnlReportSlice.reducer;